import { createContext, useContext } from "react";

export type ButtonAnalyticsContextValue = {
    /**
     * string to prepend all event names
     */
    namePrefix?: string;

    /**
     * Indicates the related feature or module, such as `searchmodule`, `AddToPlaylistmodule`, `uploadmodule`, or `attachmentsmodule`.
     */
    applicationFeature?: string;

    /**
     * Explains the placement of the button within the UI.
     * Use values like header, footer, modal box, tab, or card.
     * It helps differentiate elements with similar names but different positions.
     * corresponds to var4/buttonInfo
     */
    location?: string;
};

export const ButtonAnalyticsContextDefaultValue: ButtonAnalyticsContextValue = {};

/**
 * React context for managing button analytics metadata, such as name prefix, application feature, and module name.
 * @see ButtonAnalyticsProvider.
 */
export const ButtonAnalyticsContext = createContext<ButtonAnalyticsContextValue>(ButtonAnalyticsContextDefaultValue);

/**
 * Hook for accessing the ButtonAnalyticsContext
 */
export const useButtonAnalyticsContext = (): ButtonAnalyticsContextValue => {
    return useContext(ButtonAnalyticsContext);
};
